import React from "react";
import { twMerge } from "tailwind-merge";

export const Delete = ({ className }: { className?: string }) => {
  return (
    <svg
      width={14}
      height={15}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={twMerge("gg-fill-[#9493A3] hover:gg-fill-red-500", className)}
    >
      <path d="M11.656 4.615c.29.034.52.279.531.574v8.076c-.006.896-.775 1.71-1.708 1.729-2.315.014-4.63 0-6.944 0-.905-.006-1.723-.778-1.728-1.729V5.189a.6.6 0 0 1 .486-.57.595.595 0 0 1 .659.48c.006.04.006.05.007.09 0 2.694-.017 5.388 0 8.082.006.297.26.563.57.57q3.466.021 6.934 0a.595.595 0 0 0 .57-.579V5.19a.6.6 0 0 1 .486-.57c.086-.013.108-.006.136-.005M8.17 5.767a.5.5 0 0 1 .189.043.59.59 0 0 1 .352.468c.003.03.003.036.004.065v4.614a.5.5 0 0 1-.057.25c-.17.353-.74.435-.99.083a.6.6 0 0 1-.107-.333V6.343a.586.586 0 0 1 .513-.573c.062-.006.076-.003.097-.002zm-2.283 0a.59.59 0 0 1 .54.511c.003.03.003.036.004.065v4.614a.5.5 0 0 1-.057.25c-.17.353-.74.435-.99.083a.6.6 0 0 1-.106-.333V6.343a.586.586 0 0 1 .513-.573c.062-.006.076-.003.096-.002m-1.774-3.46V.576c.003-.105.013-.134.032-.191a.59.59 0 0 1 .48-.382C4.655 0 4.662 0 4.691 0h4.614l.032.001a.5.5 0 0 1 .189.043.59.59 0 0 1 .352.469c.003.028.003.036.004.065v1.729h2.883l.05.002c.045.006.056.006.1.017.428.115.567.81.139 1.058a.5.5 0 0 1-.289.076H1.232c-.045-.001-.056 0-.1-.009C.68 3.372.496 2.642.943 2.384a.5.5 0 0 1 .289-.077zm4.613 0V1.152h-3.46v1.153z" />
    </svg>
  );
};
